import useToast from "./useToast"

export default function useForm() {
  const { toastError } = useToast()
  const formError = (errors: any[]): string => {
    if (!errors || errors.length == 0) {
      return ''
    }
    if (!errors[0].$message) {
      return 'Confira as informações preenchidas e tente novamente'
    }
    return errors[0].$message
  }

  const invalidForm = (...forms: any): boolean => {
    if (!forms) return false
    let errors: any[] = []
    for (let form of forms) {
      errors = errors.concat(form.$errors)
    }
    errors = errors.filter(el => el !== undefined)
    const error = formError(errors)
    if (error) {
      toastError(error)
      return true
    }
    return false
  }


  return {
    invalidForm
  }
}